<template>
  <v-layout wrap>
    <v-flex xs12>
      <AppForm label="抽出条件" />
    </v-flex>
    <v-flex xs12 offset-xs1>
      <AppForm label="購読率指定" />
    </v-flex>
    <v-flex xs12 offset-xs1 pl-4>
      <v-layout>
        <v-flex xs1>
          <v-layout>
            <v-flex>
              <v-form ref="subscriptionRate">
                <v-text-field
                  @keydown.arrow-down.prevent
                  @keydown.arrow-up.prevent
                  @wheel.prevent
                  v-model.number="menuSetting.subscriptionRate"
                  :rules="rules"
                  type="number"
                />
              </v-form>
            </v-flex>
            <v-flex mt-4 pt-12>
              <v-icon>mdi-percent</v-icon>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs1 ml-4>
          <v-select
            v-model="menuSetting.conditions"
            :items="conditions"
            item-text="name"
            item-value="value"
          />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 mt-3>
      <AppForm label="対象地域" />
    </v-flex>
    <v-flex xs12 offset-xs1>
      <AppAreaSelectorWithSplitGroupCheckbox :form="form" />
    </v-flex>
    <v-flex xs12>
      <AppForm label="備考" />
    </v-flex>
    <v-flex xs10 mt-1 offset-xs1>
      <v-textarea v-model="menuSetting.memo" outline />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    conditions() {
      return [
        { name: '以上', value: 'greater' },
        { name: '以下', value: 'less' },
      ]
    },
    menuSetting() {
      return this.form.campaign.menuSetting.orderDescription
    },
    errorMessage() {
      const errorMessages = []
      if (!this.$refs.subscriptionRate.validate())
        errorMessages.push('新聞購読率を正しく入力してください')
      if (!this.menuSetting.conditions)
        errorMessages.push('以上か以下のどちらかを選択してください')
      if (
        this.menuSetting.area.isEmpty(
          this.menuSetting.administrativeDistrictType,
        )
      ) {
        errorMessages.push('対象地域を指定してください')
      }
      return errorMessages.length === 0 ? '' : errorMessages
    },
    rules() {
      return [
        p => (p !== undefined && p !== '') || '入力してください',
        p => p >= 0 || '正の数を入力してください',
        p => p % 1 === 0 || '整数を入力してください',
        p => this.validateGreater(p) || '1以上85以下の数字を入力してください',
        p => this.validateLess(p) || '40以上100以下の数字を入力してください',
      ]
    },
  },
  methods: {
    validateGreater(value) {
      if (this.menuSetting.conditions === 'less') return true
      return value >= 1 && value <= 85
    },
    validateLess(value) {
      if (this.menuSetting.conditions === 'greater') return true
      return value >= 40 && value <= 100
    },
  },
}
</script>

<style scoped>
.v-textarea >>> textarea {
  margin-top: 0;
}
</style>
